let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9U2T5")).then(() => parcelRequire('dzNDb'));